module.exports = __webpack_public_path__ + "img/psd.6fad818f.svg";